const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      stroke="#111"
      strokeWidth={0.3}
      d="M15.378 15.283V8.715c0-.691-.183-1.223-.549-1.595-.366-.372-.888-.558-1.566-.558h-2.86c-.677 0-1.198.186-1.564.558-.366.372-.549.904-.549 1.595v6.568c0 .691.183 1.223.549 1.595.366.372.887.558 1.564.558h2.86c.678 0 1.2-.186 1.566-.558.366-.372.549-.904.549-1.595Zm-1.68-.146c0 .199-.054.35-.161.454-.108.105-.264.157-.469.157h-2.46c-.205 0-.362-.052-.469-.157-.107-.104-.16-.255-.16-.454V8.863c0-.2.053-.352.16-.457.107-.104.264-.156.47-.156h2.46c.204 0 .36.052.468.156.107.105.161.257.161.457v6.274ZM18.497 21.192V2.804c0-.223.082-.413.247-.57A.819.819 0 0 1 19.326 2c.224 0 .42.078.589.235a.749.749 0 0 1 .252.569v18.388a.75.75 0 0 1-.252.571.836.836 0 0 1-.589.235.819.819 0 0 1-.582-.235.757.757 0 0 1-.247-.57ZM3.5 21.192V2.804c0-.223.082-.413.248-.57A.819.819 0 0 1 4.33 2c.224 0 .42.078.588.235a.749.749 0 0 1 .252.569v18.388a.75.75 0 0 1-.252.571.836.836 0 0 1-.588.235.819.819 0 0 1-.582-.235.757.757 0 0 1-.248-.57Z"
    />
  </svg>
)
export default SvgComponent
